export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuItemScrolled.vue?vue&type=template&id=338714f8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItemScrolled.vue?vue&type=template&id=338714f8&scoped=true&
// module id = 138
// module chunks = 0